<div class="timeline-comment-box" >
  <textarea class="form-control"  [(ngModel)]="commentaire" [class.not-empty]="commentaire.length > 0" rows="2" placeholder="Ajouter un commentaire"></textarea>



  @if (commentaire.length > 0) {
    <button mat-raised-button color="warn"
      [disabled]="isBusy"
      (click)="postComment()"
    >{{ (editMode) ? 'Modifier':'Envoyer' }}</button>
  }

  @if (editMode) {
    <button mat-raised-button
      [disabled]="isBusy"
      (click)="cancel()"
    >Annuler</button>
  }
</div>
